import React from 'react';
import {
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

import { useIsPhone } from '@hooks';
import { tableHeaderCellSx } from 'components/common/tableStyles';
import { TEAMS_TABLE_HEADERS } from '../constants/headers';

const MEMBER_CARD_HEIGHT = 98;

export const TeamsListingSkeleton: React.FC = () => {
  const isPhone = useIsPhone();

  if (isPhone)
    return (
      <Stack gap={1}>
        {[...Array(4)].map((_, i) => (
          <Skeleton key={i} variant="rounded" height={MEMBER_CARD_HEIGHT} />
        ))}
      </Stack>
    );

  return (
    <Table>
      <TableHead>
        <TableRow>
          {TEAMS_TABLE_HEADERS.map((header) => (
            <TableCell key={header} sx={tableHeaderCellSx}>
              <Skeleton />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {[...Array(8)].map((_, i) => (
          <TableRow key={i}>
            {TEAMS_TABLE_HEADERS.map((_, j) => (
              <TableCell key={j}>
                <Skeleton />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
